﻿import { upOrDownOnScrollWheel } from "./HelperFunctions";

export function scrollHandler($: JQueryStatic): void {
    const body = document.querySelector("body");

    if (!body) return;

    if (body.classList.contains("page-post-results")) {
        const postFilters: HTMLElement | null = document.querySelector(
            ".page-post-results__filters-container"
        );
        if (postFilters) {
            upOrDownOnScrollWheel(postFilters);
        }
    }
    if (body.classList.contains("page-job-results")) {
        const jobFilters: HTMLElement | null = document.querySelector(
            ".page-job-results__filters-container"
        );

        if (jobFilters) {
            upOrDownOnScrollWheel(jobFilters);
        }
    }
}
